import shareMutations from 'vuex-shared-mutations'

export default ({ store }) => {
  window.onNuxtReady((nuxt) => {
    shareMutations({
      predicate: ['TOGGLE_AUTH_FORM', 'SET_USER_IS_LOGIN']
    })(store)
  })
}
